import * as z from "zod";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum ProductTypeFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export const ProductTypeFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.PRODUCT_TYPE,
  ProductTypeFilterQuery,
  z.array(z.string()),
);

export type ProductTypeFilter = z.infer<typeof ProductTypeFilterSchema>;
